<nav class="navbar navbar-expand-lg navbar-light fixed-top shadow-sm" id="mainNav">
  <div class="container px-5">
    <a class="navbar-brand fw-bold" href="#page-top">
      <img src="./assets/img/doktorslogo.png" style="width:150px" /></a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarResponsive"
      aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
      Menu
      <i class="bi-list"></i>
    </button>
  </div>
  <div class="collapse navbar-collapse" id="navbarResponsive">
    <form [formGroup]="cityForm" (ngSubmit)="onSubmit(cityForm.value)">
      <ul class="navbar-nav ms-auto me-4 my-3 my-lg-0">
        <!-- <li class="nav-item" style="align-items: stretch !important;">
                <a class="nav-link me-lg-3" href="#download">Contact</a>
              </li> -->
        <li class="nav-item" style="padding: 4px;">
          <input type="text" formControlName="name" class="form-control form-control-sm" id="exampleInputEmail1"
            aria-describedby="emailHelp" placeholder="City">
        </li>
        <!-- <li class="nav-item"  style="padding: 4px;">
                <select class="form-control form-control-sm">
                    <option>Small select</option>
                  </select>
              </li> -->
        <li class="nav-item" style="padding: 4px;">
          <button class="btn btn-primary rounded-pill px-3  mb-2mb-lg-0" data-bs-toggle="modal"
            data-bs-target="#feedbackModal" type="submit" [disabled]="!cityForm.valid">
            <span class="d-flex align-items-center">
              <i class="bi bi-file-person me-2"></i>
              <span class="small">Search</span>
            </span>
          </button>
        </li>
      </ul>
    </form>
  </div>
</nav>
<p>find-doctor works!</p>
<!-- Mashead header-->

<section id="team" class="team section-bg">
  <div class="container">
    <div class="section-title text-center" *ngIf="CityDoctor && CityDoctor.total > 1">
      <h2>Top Doctors of <b style="color:#5bcfcc">{{CityDoctor.docs[0].address.city}}</b></h2>
      <!-- <h2 >{{CityDoctor[0].address.city}}</h2> -->
      <!-- <p style="padding-bottom: 20px;">Magnam dolores commodi suscipit. Necessitatibus eius consequatur ex aliquid fuga
        eum quidem. Sit sint consectetur velit.</p> -->
    </div>
    <div class="section-title" *ngIf="CityDoctor && CityDoctor.total < 1">
      <h2 style="color: red;">Doctor not available</h2>
      <!-- <h2 >{{CityDoctor[0].address.city}}</h2> -->
      <p style="text-align: center;">please try again!</p>
    </div>
    <form [formGroup]="findDoctorForm" style="    padding-bottom: 25px;">
      <div class="search-doctor">
        <div class="row">
          <div class="col-md-4"></div>
          <div class="col-md-4">
            <input (input)="filterDoctor($event.target.value)" autocomplete="off" type="text" formControlName="doctor"
              class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"
              placeholder="Find Doctor by Name">
          </div>
          <div class="col-md-4">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true" style="position: absolute;
                      margin-left: -75px;
                      margin-top: 12px;"></span>
            <button (click)="closeFind()" *ngIf="isFind" id="closesearchDoctor"><span
                aria-hidden="true">&times;</span></button>
          </div>
        </div>
      </div>
    </form>
    <div class="row">

      <div class="col-lg-3 col-md-6 col-6 d-flex align-items-stretch" *ngFor="let item of docarry">
        <div class="member" style="width: 200px;">
          <div class="member-img" Id="CityDoctor1" *ngIf="item.doctorId">
            <img [src]="this.path + item.doctorId.profileImageThumbnail" routerLink="/download"
              style="margin-bottom: 15px; padding-top: 15px;     min-height: 150px; width: 100%;" class="img-fluid"
              alt="">
            <img src="assets/img/doctor.png" class="img-fluid" routerLink="/download" alt=""
              style="margin-bottom: 15px; padding-top: 15px;     min-height: 150px;"
              *ngIf="!item.doctorId.profileImageThumbnail">
            <div class="social" style="background: #5bcfcc61;">
              <a class="btn btn-sm btn-dark " routerLink="/download" id="appointmentbutton">BOOK APPOINTMENT</a>
              <!-- <a href=""><i class="icofont-twitter"></i></a>
                    <a href=""><i class="icofont-facebook"></i></a>
                    <a href=""><i class="icofont-instagram"></i></a>
                    <a href=""><i class="icofont-linkedin"></i></a> -->
            </div>
          </div>
          <div class="member-img" Id="filterDoctor" *ngIf="!item.doctorId">
            <img (click)="sendDoctor(item._id)" [src]="this.path + item.profileImageThumbnail"
              style="margin-bottom: 15px; padding-top: 15px;     min-height: 150px; width: 100%;" class="img-fluid"
              alt="" *ngIf="item.profileImageThumbnail">
            <img (click)="sendDoctor(item._id)" src="assets/img/doctor.png" class="img-fluid" alt=""
              style="margin-bottom: 15px; padding-top: 15px;     min-height: 150px;"
              *ngIf="!item.profileImageThumbnail">
            <div class="social" style="background: #5bcfcc61;">
              <a class="btn btn-sm btn-dark " style="color: white;" id="appointmentbutton">BOOK APPOINTMENT</a>
              <!-- <a href=""><i class="icofont-twitter"></i></a>
                    <a href=""><i class="icofont-facebook"></i></a>
                    <a href=""><i class="icofont-instagram"></i></a>
                    <a href=""><i class="icofont-linkedin"></i></a> -->
            </div>
          </div>
          <div class="member-info" id="detailsbefore" *ngIf="item.doctorId">
            <h4>{{item.doctorId.name}}</h4>
            <span>{{item.doctorId.degree}}</span>
          </div>
          <div class="member-info" id="detailsafter" *ngIf="!item.doctorId">
            <h4>{{item.name}}</h4>
            <span>{{item.degree}}</span>
          </div>
        </div>
      </div>



    </div>
    <div class="row" id="viewmore" *ngIf="!isFind">

      <div class="col-md-12 text-center" *ngIf="pages > page ">
        <button (click)="incount()" id="incount" type="button" class="btn btn-primary">View More Doctors</button>
      </div>
    </div>
    <div class="row" id="viewmore1" *ngIf="isFind && pageOfFind < pagesOfFind">

      <div class="col-md-12 text-center">
        <button (click)="incount1()" id="incount" type="button" class="btn btn-primary">View More Doctors</button>
      </div>
    </div>
  </div>
</section>


<!-- End Team Section -->
<!-- <form [formGroup]="cityForm" (ngSubmit)="onSubmit(cityForm.value)">
<input formControlName="name">
<button type="submit" class="w-100 mb-2 btn btn-lg rounded-4 btn-primary" [disabled]="!cityForm.valid" >Submit</button>
      </form> -->
<footer id="footer">
  <div class="footer-top">
    <div class="container">
      <div class="row">
        <div class="col-lg-3 col-md-6 footer-contact">
          <!-- <h3>Resi.</h3> -->
          <img src="./assets/img/pooja.png" style="width:150px;z-index:999;" />
          <p>
            A108 Adam Street <br />
            New York, NY 535022<br />
            United States <br /><br />
            <strong>Phone:</strong> +1 5589 55488 55<br />
            <strong>Email:</strong> help@doqmatokens.com<br />
          </p>
        </div>

        <div class="col-lg-2 col-md-6 footer-links">
          <h4>Useful Links</h4>
          <ul>
            <!-- <li>
                    <i class="bx bx-chevron-right"></i> <a href="#">Home</a>
                  </li> -->
            <!-- <li>
                    <i class="bx bx-chevron-right"></i> <a href="#">About us</a>
                  </li> -->
            <li>
              <i class="bx bx-chevron-right"></i> <a href="#">Services</a>
            </li>
            <li>
              <i class="bx bx-chevron-right"></i>
              <a href="termsconditoin">Terms of service</a>
            </li>
            <li>
              <i class="bx bx-chevron-right"></i>
              <a href="privacypolicy">Privacy policy</a>
            </li>
            <li>
              <i class="bx bx-chevron-right"></i>
              <a href="refundpolicy">Refund policy</a>
            </li>
          </ul>
        </div>

        <div class="col-lg-4 col-md-6 footer-newsletter" style="text-align:center">
          <h4>Download the app now</h4>
          <p>
            Get latest news on DOQMA on your mail and stay connected.
          </p>
          <!-- <form action="" method="post">
                  <input type="email" name="email" /><input
                    type="submit"
                    value="Subscribe"
                  />
                </form> -->
          <a class="me-lg-3 mb-4 mb-lg-0" href="https://play.google.com/store/apps/details?id=com.paspatient"><img
              class="app-badge" src="assets/img/google-play-badge.svg" alt="..." /></a>
        </div>
      </div>
    </div>
  </div>

  <div class="container d-md-flex py-4">
    <div class="mr-md-auto text-center text-md-left">
      <div class="copyright">
        &copy; Copyright <strong><span>Mavin Globus</span></strong>. All Rights Reserved
      </div>
    </div>
    <div class="social-links text-center text-md-right pt-3 pt-md-0">
      <!-- <a href="#" class="twitter"><i class="bi bi-twitter"></i></a> -->
      <!-- <a href="#" class="facebook"><i class="bi bi-facebook"></i></a> -->
      <!-- <a href="#" class="instagram"><i class="bi bi-instagram"></i></a> -->
      <!-- <a href="#" class="google-plus"><i class="bi bi-skype"></i></a> -->
      <!-- <a href="#" class="linkedin"><i class="bi bi-linkedin"></i></a> -->
    </div>
  </div>
</footer>